<template>
  <div class="tour-360">
		<component :is="currentComponent"></component>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Matterport from './matterport/matterport.vue'
  import IGuide from './iguide/iguide.vue'
  import CloudPano from './cloudPano/cloudPano.vue'

  export default {
    components: {
      Matterport,
      IGuide,
      CloudPano
    },
    computed: {
      ...mapState('tours', ['tour360']),
      currentComponent () {
        const { matterport, iguide, cloudPano } = this.tour360
        
        return (matterport && 'matterport') || (iguide && 'iGuide') || (cloudPano && 'cloudPano')
      }
    }
  }
</script>

<style lang="scss">
  .tour-360 {
    position: relative;
    padding-top: 56.25%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
</style>
